import Model, { attr, belongsTo, type AsyncBelongsTo } from '@ember-data/model';
import type GlobalFlowModel from 'garaje/models/global-flow';
import adapter from 'garaje/utils/decorators/adapter';

@adapter('id-scan-page')
class GlobalIdScanPageModel extends Model {
  @belongsTo('global-flow', { async: true, inverse: 'idScanPage' }) declare flow: AsyncBelongsTo<GlobalFlowModel>;
  @attr('boolean') declare enabled: boolean;
  @attr('boolean', { defaultValue: false }) declare imagesVisible: string;
  @attr('string', { defaultValue: 'back' }) declare camera: string;
  @attr('string', { defaultValue: null }) declare rescanAfter: string | null;
  @attr('number', { defaultValue: 12 }) declare rescanAfterValue: number;

  isGlobal = true;
}

export default GlobalIdScanPageModel;

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'global-id-scan-page': GlobalIdScanPageModel;
  }
}
